import React, {Fragment, useEffect, useState} from "react";
import {DropdownMenu, DropdownToggle, Dropdown} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {FaBell} from "react-icons/fa";
import {
  deleteNotifications,
  markAllNotificationAsRead,
  requestNotifications,
} from "../../redux/Actions/notifications.action";
import {
  getNotifications,
  getUnreadCount,
} from "../../redux/Selectors/notifications.selector";
import Button from "../Button";
import DeleteModal from "../Modal/DeleteModal";
import NotificationsList from "./NotificationsList";
import "./notification.scss";

/** This component will make API call to backend server to get notifications.
 * And will display notification in reactstrap Dropdown component
 */

const NotificationMenu = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(getNotifications);
  const unreadCount = useSelector(getUnreadCount);
  const [modalStatus, setModalStatus] = useState(false);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    dispatch(requestNotifications());
  }, [dispatch]);

  const toggleDeleteModal = () => {
    setModalStatus(true);
  };

  const toggleDropdown = () => {
    setOpen(!isOpen);
  };

  const markAllAsRead = () => {
    dispatch(markAllNotificationAsRead());
  };

  const handleDelete = () => {
    const callback = () => {
      setModalStatus(false);
    };
    dispatch(deleteNotifications(callback));
  };

  return (
    <Fragment>
      {modalStatus && (
        <DeleteModal
          header={"Delete all notifications"}
          modalBody={"Are you sure you want to delete all notifications ?"}
          onClose={() => setModalStatus(false)}
          onDelete={handleDelete}
          open={modalStatus}
        />
      )}
      {notifications && (
        <Dropdown isOpen={isOpen} toggle={toggleDropdown} nav>
          <DropdownToggle
            className="pr-0 notification-dropdown-toggle"
            data-cy={"notification-menu"}
            nav
            onClick={toggleDropdown}
          >
            <span data-count={unreadCount} className={"notification-icon cursor-pointer"}>
              <FaBell />
            </span>
          </DropdownToggle>
          <DropdownMenu right>
            {" "}
            <NotificationsList data={notifications} />
            {notifications.length > 0 && (
              <div style={{margin: "15px 10px"}} className="d-flex justify-content-end">
                {unreadCount > 0 && (
                  <Button
                    onClick={markAllAsRead}
                    type={"notification-button"}
                    data-cy={"mark-all-as-read"}
                  >
                    Mark all as read
                  </Button>
                )}
                <Button
                  onClick={toggleDeleteModal}
                  type={"notification-button"}
                  data-cy={"delete-all"}
                >
                  Delete all
                </Button>
              </div>
            )}
          </DropdownMenu>
        </Dropdown>
      )}
    </Fragment>
  );
};

export default NotificationMenu;
